import React, { forwardRef } from 'react';
import '../../styles/foundation/CenteredContentPage.css';

const CenteredContentPage = forwardRef(
    ({ children, isDisabled = false }, ref) => {
        return (
            <div ref={ref} className={`centered-content-page ${isDisabled ? 'disabled' : ''}`}>
                {children}
            </div>
        );
    }
);

CenteredContentPage.displayName = 'CenteredContentPage';

export default CenteredContentPage;
